import { createFileRoute } from "@tanstack/react-router";

import { InvoicesPage } from "@/features/my/settings/account/invoices";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/invoices/",
)({
  component: InvoicesPage,
});
